export default {"src":"/_next/static/media/flag_blue.05931af1.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};